import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IPbiReport } from './business-objects/types';
import PowerBiEditReport from './PowerBiEditReport';

export interface IEditPbiReportProps {
  activeReport: IPbiReport;
}

class EditPbiReport extends React.Component<IEditPbiReportProps> {
  public render() {
    return (
      <div>
        {this.props.activeReport && (
          <PowerBiEditReport
            reportId={this.props.activeReport.reportId}
            type='report'
          />
        )}
      </div>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    activeReport: state.PowerBI.activeReport,
  };
}

const mapDispatchToProps = {};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EditPbiReport)
);
